var module = angular.module('octopusApp.library');

module.controller('StepTemplateRunController', function ($scope, $stateParams, $location,
                                                        busy, octopusRepository, unsavedChanges,
                                                        templateParameterModal, pluginRegistry, $uibModal, $q, actionUpdater) {
    $scope.resolveLink = octopusRepository.resolve;

    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var id = $stateParams["id"];
    var actionType = $stateParams["actionType"];
    var retry = $stateParams["retry"];
    
    $scope.actionTemplate = null;
    $scope.vm = {};
    $scope.vm.selectionModes = ['Machines', 'Environments'];
    $scope.vm.selectionMode = $scope.vm.selectionModes[0];
    $scope.vm.environmentIds = [];
    $scope.vm.targetRoles = [];
    $scope.vm.machineIds = [];
    $scope.action = { Properties: {} };

    $scope.unsavedChanges = unsavedChanges;

    var updateLocalNames = function () {
        if ($scope.actionTemplate && $scope.actionTemplate.Parameters) {
            $scope.localNames = _.pluck(_.sortBy($scope.actionTemplate.Parameters, 'Name'), 'Name');
        } else {
            $scope.localNames = [];
        }
    };

    var dependsOnStepName = function(actionTemplate){
        return actionTemplate.Parameters && actionTemplate.Parameters.some(function(p){
                                                                                return p.DisplaySettings &&  p.DisplaySettings["Octopus.ControlType"] === "StepName";
                                                                            });
    };

    var resources = [
        octopusRepository.ActionTemplates.get(id),
        octopusRepository.Environments.all(), 
        octopusRepository.Machines.all(), 
        octopusRepository.MachineRoles.all()
    ];

    isLoading.promise($q.all(resources).then(function (data) {
        $scope.actionTemplate = data[0];
        $scope.vm.environments = data[1];
        $scope.vm.machines = data[2];
        $scope.vm.availableRoles = data[3];
        $scope.isCommunityTemplate = $scope.actionTemplate.CommunityActionTemplateId != null;
        updateLocalNames();
        unsavedChanges.saved();

        $scope.dependsOnStepName = dependsOnStepName($scope.actionTemplate);

        if (retry) {
            isLoading.promise(octopusRepository.Tasks.get(retry).then(function (retried) {
                $scope.action.Properties = retried.Arguments.Properties;
                // Sensitive values for ad-hoc tasks aren't available to be re-used on the server - 
                // the API needs to indicate that we have a value for the property, but running 
                // a new task without changing those values will result in using no value (instead
                // of the last saved value). This is correct behavior from the API/server and ensures
                // no one can re-submit a task using sensitive values without knowing the values. 
                // But it's misleading to our UI on this page to show that we have a value, as users
                // would expect it to just work. So we clear any sensitive values here.
                for (var prop in $scope.action.Properties) {  
                    if (_.has($scope.action.Properties[prop], 'HasValue')) {
                        $scope.action.Properties[prop] = null;
                    }
                }

                if (retried.Arguments.MachineIds && retried.Arguments.MachineIds.length > 0) {
                    $scope.vm.machineIds = retried.Arguments.MachineIds;
                    $scope.vm.selectionMode = 'Machines';
                } else {
                    $scope.vm.environmentIds = retried.Arguments.EnvironmentIds;
                    $scope.vm.targetRoles = retried.Arguments.TargetRoles;
                    $scope.vm.selectionMode = 'Environments';
                }

                unsavedChanges.saved();
            }));
        }
    }));

    $scope.run = function() {
        var task = {
            Name: 'AdHocScript',
            Description: 'Run step template: ' + $scope.actionTemplate.Name,
            Arguments: {
                ActionTemplateId: $scope.actionTemplate.Id,
                Properties: $scope.action.Properties
            }
        };

        if ($scope.vm.selectionMode === 'Machines') {
            if ($scope.vm.machineIds.length === 0) {
                isSaving.showError('At least one deployment target must be selected.');
                return;
            }
            task.Arguments.MachineIds = $scope.vm.machineIds;
        } else {
            task.Arguments.EnvironmentIds = $scope.vm.environmentIds;
            task.Arguments.TargetRoles = $scope.vm.targetRoles;
        }

        isSaving.promise(octopusRepository.Tasks.create(task).then(function (created) {
            unsavedChanges.saved();
            $location.path('/tasks/' + created.Id);
        }));
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/step_template_run_controller.js
// module id = 467
// module chunks = 1